export default function PageBanner({ title, subtitle, image }) {
  return (
    <div
      className="relative h-[220px] w-full bg-center bg-cover"
      style={{ backgroundImage: `url(${image})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-8 md:px-16">
        <h1 className="text-3xl md:text-4xl font-bold text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="text-gray-200 mt-2 max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}